import styled from "styled-components";
import ImgArrow from "@/styles/assets/svg/icon_select_arrow.svg";

export const SelectBox = styled.div`
  display: flex;
  width: 100%;
  font-size: 1.4rem;
  background: ${(props) => props.theme.colors.white100};

  &:focus {
    outline: none;
    border: 2px solid ${(props) => props.theme.colors.primary100};
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 56px;
  padding: 0 30px 0 16px !important;
  color: ${(props) => props.theme.colors.inputLabel};
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  border-radius: 6px;
  border-radiu: 
  -webkit-appearance: none;
  -mox-appearance: none;
  appearance: none;
  background-image: url(${ImgArrow});
  background-repeat: no-repeat;
  background-size: 26px 26px;
  background-position: 95% center;
  background-color: transparent;

  &::-ms-expand {
    display: none;
  }

  &:focus {
    outline: none;
    border: 2px solid ${(props) => props.theme.colors.primary100};
  }
`;

export const Placeholder = styled.option`
  color: ${(props) => props.theme.colors.inputPlaceholder};
  font-size: 1.2rem;

  &[value=""] [disabled] {
    display: none;
  }
`;
